export type TagStyle = {
  pillClassName: string
  textClassName: string
}

const RED: TagStyle = {
  pillClassName: 'bg-red-50',
  textClassName: 'text-red-700'
}

const GREEN: TagStyle = {
  pillClassName: 'bg-green-50',
  textClassName: 'text-green-700'
}

const BLUE: TagStyle = {
  pillClassName: 'bg-blue-50',
  textClassName: 'text-blue-700'
}

const YELLOW: TagStyle = {
  pillClassName: 'bg-orange-50',
  textClassName: 'text-orange-700'
}

const NEUTRAL: TagStyle = {
  pillClassName: 'bg-neutral-100',
  textClassName: 'text-neutral-700'
}

const STYLES: Record<string, TagStyle> = {
  red: RED,
  green: GREEN,
  yellow: YELLOW,
  blue: BLUE,
  neutral: NEUTRAL
}

export default function getTagStyle(color: string): TagStyle {
  return STYLES[color] ?? NEUTRAL
}
